import { Pane, Heading, Paragraph, Text } from 'evergreen-ui';
import HeroBanner from '../commons/HeroBanner'; // Corretto il path rispetto all'originale

export default function LaCasaPage() {
  return (
    <Pane className="public-page-container">
      <HeroBanner 
        title="Vivere insieme" 
        bgImage="/lacasa (2).png" 
      />
      
      <Pane maxWidth={800} marginX="auto" paddingY={60} paddingX={20} textAlign="center">
        <Paragraph size={600} marginBottom={16}>La casa è uno spazio di vita.</Paragraph>
        <Paragraph size={600} marginBottom={16}>Qui si studia, si cucina, si cresce.</Paragraph>
        <Paragraph size={600} marginBottom={48} color="muted">Qui si impara a stare insieme.</Paragraph>
        
        <Pane display="flex" flexWrap="wrap" gap={32} justifyContent="center">
          <Pane flex={1} minWidth={220} border="default" padding={24} borderRadius={8} hoverElevation={3} cursor="default">
            <Heading size={600} marginBottom={16} color="success">Spazi</Heading>
            <Text size={400} display="block">Ambienti accoglienti</Text>
            <Text size={400} display="block" color="muted">Spazi condivisi</Text>
          </Pane>
          
          <Pane flex={1} minWidth={220} border="default" padding={24} borderRadius={8} hoverElevation={3} cursor="default">
            <Heading size={600} marginBottom={16} color="success">Routine</Heading>
            <Text size={400} display="block">Giornate strutturate</Text>
            <Text size={400} display="block" color="muted">Piccole abitudini che danno sicurezza</Text>
          </Pane>
          
          <Pane flex={1} minWidth={220} border="default" padding={24} borderRadius={8} hoverElevation={3} cursor="default">
            <Heading size={600} marginBottom={16} color="success">Relazioni</Heading>
            <Text size={400} display="block">Educatori presenti</Text>
            <Text size={400} display="block" color="muted">Relazioni autentiche</Text>
          </Pane>
        </Pane>
      </Pane>
    </Pane>
  );
}